/*
 * TermsAndConditionsConstants
 */

export const LOAD_USERS = 'foundry/TermsAndConditions/LOAD_USERS';
export const LOAD_USERS_SUCCESS = 'foundry/TermsAndConditions/LOAD_USERS_SUCCESS';
export const LOAD_USERS_FAILURE = 'foundry/TermsAndConditions/LOAD_USERS_FAILURE';

export const LOAD_CSRF_TOKEN = 'foundry/TermsAndConditions/LOAD_CSRF_TOKEN';
export const LOAD_CSRF_TOKEN_SUCCESS = 'foundry/TermsAndConditions/LOAD_CSRF_TOKEN_SUCCESS';
export const LOAD_CSRF_TOKEN_FAILURE = 'foundry/TermsAndConditions/LOAD_CSRF_TOKEN_FAILURE';

export const AGREE_TO_TERMS = 'foundry/TermsAndConditions/AGREE_TO_TERMS';
export const AGREE_TO_TERMS_SUCCESS = 'foundry/TermsAndConditions/AGREE_TO_TERMS_SUCCESS';
export const AGREE_TO_TERMS_FAILURE = 'foundry/TermsAndConditions/AGREE_TO_TERMS_FAILURE';

export const DECLINE_TERMS = 'foundry/TermsAndConditions/DECLINE_TERMS';
export const DECLINE_TERMS_SUCCESS = 'foundry/TermsAndConditions/DECLINE_TERMS_SUCCESS';
export const DECLINE_TERMS_FAILURE = 'foundry/TermsAndConditions/DECLINE_TERMS_FAILURE';

export const CHANGE_AGREE_BUTTON_STATE = 'foundry/TermsAndConditions/CHANGE_AGREE_BUTTON_STATE';

export const MANAGE_HISTORY = 'foundry/TimeTravel/MANAGE_HISTORY';

